import {useEffect} from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  // relocate to dispatch directory. this will allow running app from dispatch.fleetcommnad.io and apps.fleetcommand.io/dispatch while transitioning from the former to the latter
  useEffect(() => {
 
    
      window.location = "/dispatch";
    

  },[])

  return null;
  /*return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );*/
}

export default App;
